import React from "react"

export default () => (
    <div className="circleB">
        <svg xmlns="http://www.w3.org/2000/svg" width="242" height="242"><circle className="circleBsvg" cx="121" cy="121" r="121"/></svg>
    </div>
)